import styled from 'styled-components'

export const BrandMark = styled.div.attrs({
  style: { color: 'white' },
})`
  display: block;
  width: fit-content;
  padding: 1px 2px 0;
  background-color: ${({ theme }) => theme.colors?.text};

  /* font-family: "DM Mono"; */
  font-weight: 500;
  font-size: 24px;
  line-height: 26px;
  letter-spacing: 0.48px;
  text-align: center;
  text-transform: uppercase;
  color: #fff;
`
